import { deleteRequest } from '..';

const deleteAssetNote = (InstanceId: string, NoteId: string) => deleteRequest(
  'assets/notes',
  { InstanceId, NoteId },
);

export default deleteAssetNote;
